module.exports = __webpack_public_path__ + "img/17.2d3e88ac.svg";